import React from "react"

import { Box, colors, InputBase } from "@mui/material"

export const TimePeriodPicker = (props: { initialValue?: string; onPick: (value: string) => void }) => {
	const { initialValue = "" } = props
	const [startTime, setStartTime] = React.useState("")
	const [endTime, setEndTime] = React.useState("")

	React.useEffect(() => {
		const [v1 = "", v2 = ""] = initialValue.split("-")
		setStartTime(v1)
		setEndTime(v2)
	}, [initialValue])

	const onBlur = () => {
		props.onPick(`${startTime}-${endTime}`)
	}

	return (
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", overflow: "hidden" }}>
			<InputBase
				type="time"
				value={startTime}
				onInput={(e: React.ChangeEvent<HTMLInputElement>) => setStartTime(e.target.value)}
				onBlur={onBlur}
				sx={{
					height: "100%",
					color: colors.grey[800],
					"input::-webkit-calendar-picker-indicator": {
						opacity: 0.6,
					},
				}}
			/>
			-
			<InputBase
				type="time"
				value={endTime}
				onInput={(e: React.ChangeEvent<HTMLInputElement>) => setEndTime(e.target.value)}
				onBlur={onBlur}
				sx={{
					height: "100%",
					color: colors.grey[800],
					"input::-webkit-calendar-picker-indicator": {
						opacity: 0.6,
					},
				}}
			/>
		</Box>
	)
}
